import { useCallback, useState } from 'react';
import { debounce } from 'underscore';
import { fetchFormsFromCrmSearch } from 'ContentData/api/Forms';
import { EMBED_VERSIONS } from 'ContentUtils/constants/FormsCRM';
const FORMS_PER_REQUEST = 5;
const getFilterGroups = ({
  formId,
  embedVersions
}) => [...(embedVersions || []).map(v => {
  if (v === EMBED_VERSIONS.V2) {
    // v2 refers to all forms before v4. These have no value for hs_embed_version
    // There may later be a backfill of embed_version for these forms
    // Until then, we need to query for v2 as "no value for hs_embed_version"
    return {
      filters: [{
        operator: 'NOT_HAS_PROPERTY',
        property: 'hs_embed_version'
      }, {
        operator: 'EQ',
        property: 'hs_form_type',
        value: 'HUBSPOT'
      }]
    };
  }
  return {
    filters: [{
      operator: 'EQ',
      property: 'hs_embed_version',
      value: v
    }, {
      operator: 'EQ',
      property: 'hs_form_type',
      value: 'HUBSPOT'
    }]
  };
}).flat(), ...(formId ? [{
  filters: [{
    operator: 'EQ',
    property: 'hs_form_id',
    value: formId
  }]
}] : [])];
const getForms = ({
  query = '',
  formId = '',
  offset = 0,
  embedVersions
}) => {
  const count = offset + FORMS_PER_REQUEST;
  return fetchFormsFromCrmSearch({
    count,
    query,
    filterGroups: getFilterGroups({
      formId,
      embedVersions
    })
  }).then(({
    hasMore,
    total,
    results
  }) => ({
    count,
    total,
    hasMore,
    results
  })).catch(() => ({
    count,
    total: count,
    hasMore: true,
    results: []
  }));
};
const useForms = () => {
  const [results, setResults] = useState([]);
  const getAll = useCallback(options => getForms(options).then(res => {
    setResults(res.results);
    return res;
  }).catch(e => {
    setResults([]);
    return e;
  }), []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getAllDebounced = useCallback(debounce((options, cb) => {
    getAll(options).then(res => {
      cb(res);
    }).catch(() => cb({
      count: 0,
      total: 0,
      hasMore: true,
      results: []
    }));
  }, 300), [getAll]);
  const getByFormId = useCallback(formId => {
    const fromResults = results.find(r => r.properties.hs_form_id.value === formId);
    if (fromResults) {
      return Promise.resolve(fromResults);
    }
    return getForms({
      formId
    }).then(({
      results: _results
    }) => _results[0]);
  }, [results]);
  return {
    getAll,
    getAllDebounced,
    getByFormId,
    results
  };
};
export default useForms;